
export function buildSummarizeUserReviewsPayload(params = {}) {
const payload = {}

  const fields = [
    'category_ids',
    'product_ids',
    'source_ids',
    'industry_ids',
    'company_ids',
    'sentiments',
    'feature_ids'
  ]

  for (const field of fields) {
    if (params[field] && params[field].length) {
      payload[field] = params[field]
    }
  }

  if (params.startTime) payload.startTime = params.startTime
  if (params.endTime) payload.endTime = params.endTime

  payload.module = params.module || 'voc'

  return payload
}

export function buildSummarizeStatisticsSummaryPayload(selectedProducts, vocStatictics) {

    const selectedIds = selectedProducts.map(p => Number(p.id));

    const payload = {
          products: Object.values(vocStatictics)
            .filter(p => selectedIds.includes(Number(p.product.id)))
            .map(({ product, ...rest }) => rest)
        };

  return payload
}

export function buildSummarizeNpsDataPayload(selectedProducts, totalNpsData) {

   const selectedIds = selectedProducts.map(p => Number(p.id))

   const payload = [
           ...Object.values(totalNpsData)
            .filter(p => selectedIds.includes(Number(p.product.id)))
        ]

  return payload
}


export function buildSummarizeReportsReviewPayload(groupBy, overall) {

    let group
      if(groupBy.id === 'product'){
           group = 'product'
        } else if (groupBy.id === 'source'){
           group = 'source'
        } else if (groupBy.id === 'industry'){
           group = 'industry'
        } else if (groupBy.id === 'company_size'){
           group = 'business_size'
        }

      const payload = {
           filter : group,
           data : overall
        }

  return payload
}

export function buildSummarizeFeaturedTopicsPayload(featuredTopicsData) {

    const cleanedFeaturedTopics = featuredTopicsData.map(item => {
           const { keywords, ...rest } = item; 
           return rest;
         });
   
    const payload = { data: cleanedFeaturedTopics}

  return payload
}

export function buildSummarizeCompetitivePositioningPayload(wlSelectedProductLeft, wlSelectedProductRight, attributeDataLeft, attributeDataRight, wlLeftProductData, wlRightProductData, categoryAvg, competitivePositioning) {
  

   const cleanedAttributeDataLeft = attributeDataLeft.map(item => {
        const { keywords, ...rest } = item; 
        return rest;
      });

       const cleanedAttributeDataRight = attributeDataRight.map(item => {
        const { keywords, ...rest } = item; 
        return rest;
      });

      const vantagePointsDataLeft = () => {
        if (wlLeftProductData.length) {
          const tempVantage = []
          wlLeftProductData.forEach((dl) => {
            const match = wlRightProductData.find((dr) => dl.id === dr.id)

            if (match) {
              if (parseFloat(dl.strength) > parseFloat(match.strength)) {
                tempVantage.push({
                  name: dl.name,
                  delta: (dl.strength - match.strength).toFixed(2)
                })
              }
            }
          })

          return tempVantage
            .sort((a, b) => b.delta - a.delta)
            .splice(0, 3)
        }

        return []
      }

      const vantagePointsDataRight = () => {
      if (wlRightProductData.length) {
        const tempVantage = []
        wlRightProductData.forEach((dl) => {
          const match = wlLeftProductData.find((dr) => {
            return dl.id === dr.id
          })
          if (match) {
            if (parseFloat(dl.strength) > parseFloat(match.strength)) {
              const obj = {
                name: dl.name,
                delta: (dl.strength - match.strength).toFixed(2)
              }
              tempVantage.push(obj)
            }
          }
        })
        return tempVantage
          .sort(function (a, b) {
            return b.delta - a.delta
          })
          .splice(0, 3)
      } else {
        return []
      }
      }

      const payload = [{
        product : wlSelectedProductLeft.name,
        data:{
          sentiments: wlLeftProductData,
          word_cloud : cleanedAttributeDataLeft,
          competitive_positioning: {
            categoryAvg: categoryAvg,
            competitiveData : competitivePositioning
          },
          vantage_capabilities: vantagePointsDataLeft()
        }
      },
      {
         product: wlSelectedProductRight.name,
         data:{
          sentiments: wlRightProductData,
          word_cloud : cleanedAttributeDataRight,
          competitive_positioning: {
            categoryAvg: categoryAvg,
            competitiveData : competitivePositioning
          },
          vantage_capabilities : vantagePointsDataRight()
        }
      }
    ]

  return payload
}

